import { render, staticRenderFns } from "./integralDetails.vue?vue&type=template&id=c76e0900&scoped=true"
import script from "./integralDetails.vue?vue&type=script&lang=js"
export * from "./integralDetails.vue?vue&type=script&lang=js"
import style0 from "./integralDetails.vue?vue&type=style&index=0&id=c76e0900&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c76e0900",
  null
  
)

export default component.exports